var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSnsTiktokFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.975 12.107a10.997 10.997 0 006.414 2.052v-4.6c-.452 0-.904-.048-1.347-.141v3.621a11 11 0 01-6.415-2.051v9.388c0 4.697-3.809 8.504-8.508 8.504a8.47 8.47 0 01-4.736-1.438A8.485 8.485 0 0013.466 30c4.7 0 8.509-3.807 8.509-8.504v-9.388zm1.662-4.641a6.41 6.41 0 01-1.662-3.754V3.12h-1.277a6.441 6.441 0 002.939 4.346zM10.355 23.838a3.891 3.891 0 014.279-6.062v-4.704a8.576 8.576 0 00-1.347-.078v3.661a3.897 3.897 0 00-5.073 3.708c0 1.519.87 2.834 2.14 3.475z",
    fill: "#FF004F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.627 10.987a11 11 0 006.415 2.052V9.418a6.44 6.44 0 01-3.406-1.952 6.441 6.441 0 01-2.939-4.346h-3.353v18.376a3.891 3.891 0 01-6.99 2.342 3.89 3.89 0 011.75-7.365c.413 0 .81.064 1.182.182v-3.66c-4.616.094-8.329 3.864-8.329 8.501 0 2.315.925 4.413 2.425 5.946a8.471 8.471 0 004.737 1.438c4.698 0 8.508-3.807 8.508-8.504v-9.389z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.042 9.417v-.979a6.416 6.416 0 01-3.406-.972 6.434 6.434 0 003.406 1.951zM20.698 3.12a6.57 6.57 0 01-.071-.528V2h-4.63v18.376a3.891 3.891 0 01-5.643 3.462 3.891 3.891 0 006.99-2.342V3.12h3.354zm-7.412 9.874v-1.043a8.601 8.601 0 00-1.167-.079c-4.7 0-8.509 3.808-8.509 8.504a8.494 8.494 0 003.773 7.066 8.472 8.472 0 01-2.426-5.946c0-4.637 3.713-8.407 8.33-8.502z",
    fill: "#00F2EA"
  })));
}

export default SvgIconSnsTiktokFilled;